import { useQuery } from '@tanstack/react-query';

import { CategorizedIndividual } from '../../../../types';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../../constants/pluginBasePath';
import { getOcrLabIndividuals } from '../../requests/getOcrLabIndividuals';

export const useOcrLabIndividuals = (
  uuid: string,
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();
  const { data, ...rest } = useQuery<
    NonPaginatedResponse<CategorizedIndividual[]> | undefined
  >({
    queryKey: [PLUGIN_BASE_PATH, 'ocr-lab-individuals', uuid],
    queryFn: () => getOcrLabIndividuals(constructGet, uuid),
    enabled: !!uuid,
    ...options,
  });
  return { ...unwrapNonPaginatedResponseDataAs(data, 'individuals'), ...rest };
};
